
  import { defineComponent, PropType } from 'vue';

  import TableTree from '@/common/components/redesigned/Table/TableTree/TableTree.vue';
  import { TTableTreeConfig } from '@/common/components/redesigned/Table/types/tableTypes';

  import { TStatisticsChartWithLegends } from '@/modules/admin/types/statistics/common';

  import {
    STATISTICS_PUBLIC_ACTIONS_NAME,
    STATISTICS_PUBLIC_GETTERS_NAME,
    STATISTICS_PUBLIC_MUTATIONS_NAME,
  } from '../../../store/statisticsPublic/name';
  import {
    TPublicViewsCountByTimeTableItem,
    TStatisticsPublicFilter,
  } from '../../../types/statistics/statistics-public';
  import {
    getStatisticsChartWithLegendsConfigs,
    STATISTICS_PUBLIC_CHART_LINE_COLORS,
  } from '../../../utils/statisticsCharts';
  import { TChartBaseConfig } from '../charts/chartTypes';
  import StatisticsVerticalColumnChart from '../charts/StatisticsVerticalColumnChart.vue';
  import StatisticsByTimeTabs from '../StatisticsByTimeTabs.vue';

  export default defineComponent({
    name: 'StatisticsPublicViewsCountByTimeTab',
    components: {
      StatisticsVerticalColumnChart,
      TableTree,
      StatisticsByTimeTabs,
    },
    props: {
      filter: {
        type: Object as PropType<TStatisticsPublicFilter>,
        required: true,
      },
    },
    data(): {
      chartConfigs: TChartBaseConfig<TStatisticsChartWithLegends>;
      tableConfig: TTableTreeConfig<TPublicViewsCountByTimeTableItem>;
      lineColors: string[];
    } {
      return {
        chartConfigs: getStatisticsChartWithLegendsConfigs({
          action: STATISTICS_PUBLIC_ACTIONS_NAME.getViewsCountByTimeChartData,
          mutation: STATISTICS_PUBLIC_MUTATIONS_NAME.setViewsCountByTimeChartData,
          getter: STATISTICS_PUBLIC_GETTERS_NAME.getViewsCountByTimeChartData,
        }),
        tableConfig: {
          columns: [
            {
              field: 'name',
              title: 'Период',
            },
            {
              field: 'viewsCount',
              title: 'Количество просмотров',
              textAlign: 'right',
              width: 188,
            },
          ],
          storePaths: {
            action: STATISTICS_PUBLIC_ACTIONS_NAME.getViewsCountByTimeTable,
            mutation: STATISTICS_PUBLIC_MUTATIONS_NAME.setViewsCountByTimeTable,
            getter: STATISTICS_PUBLIC_GETTERS_NAME.getViewsCountByTimeTable,
          },
          pagination: {
            size: 12,
          },
        },
        lineColors: STATISTICS_PUBLIC_CHART_LINE_COLORS,
      };
    },
  });
